module.exports = __webpack_public_path__ + "static/13-ca9834bebb51e53a73182e70a21ff498.png";